//#region src/function/injectScriptToElement.ts
var e = (e, t) => {
	if (!e) return;
	let n = document.createElement("div");
	n.innerHTML = e;
	let r = n.getElementsByTagName("script")[0];
	if (!r) return;
	let i = document.createElement("script");
	Object.values(r.attributes).forEach((e) => {
		i.setAttribute(e.name, e.value);
	}), r.text && (i.text = r.text), t.appendChild(i);
};
//#endregion
export { e as injectScriptToElement };

//# sourceMappingURL=injectScriptToElement.js.map